import { AxiosResponse } from 'axios';
import { get } from 'lodash-es';
import { HttpClientFactory } from '@/shared/services';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ResourceService {
  /* DEPRECATED */
  export const loadTranslations = (locale: string): Promise<any> => HttpClientFactory.baseClient
    .get(`ui-assets/access-ui/precon/${locale}.json`)
    .then((res: AxiosResponse) => res.data)
    .catch(error => {
      console.error('Failed to load translations', error);
    });

  /* DEPRECATED */
  export const loadQuestions = (): Promise<AxiosResponse> => HttpClientFactory.baseClient
    .get('configuration.json')
    .then((response: AxiosResponse) => get(response, 'data.section.questions', []));

  export const loadVideoData = (): Promise<any> => HttpClientFactory.baseClient
    .get('/api/v1/access/video')
    .then((response: AxiosResponse) => get(response, 'data', {}));
}
